<div class="background"
     [class.authenticated]="sessionService.isAuthenticated() && sessionService.isInitialized()"
     [class.public]="!sessionService.isAuthenticated()"></div>

<div class="loaderContaner loader"
     *ngIf="sessionService.LoaderInitStatus()"></div>
<ui-view name="base"></ui-view>
<ng-template ngbModalContainer></ng-template>
<ngx-loading-bar color="#ED1C24" [includeSpinner]="false"></ngx-loading-bar>
<build-version></build-version>

